import { Component, OnInit } from '@angular/core';
import { Entity } from '../entity';
import { EntityService } from '../entity.service';

import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-entity-details',
  templateUrl: './entity-details.component.html',
  styleUrls: ['./entity-details.component.css']
})
export class EntityDetailsComponent implements OnInit {
  entity = new Entity();

  constructor(
    private entityService: EntityService,
		private route: ActivatedRoute,
    private location: Location

  ) { }

  ngOnInit() {
    this.GetEntityDetails();

  }

  GetEntityDetails() {
    const entityid = +this.route.snapshot.paramMap.get('entityid');
    this.entityService.GetEntityDetails(entityid)
      .subscribe(entity =>
       { 
         this.entity = entity[0]
         console.log(this.entity)
       });
  }

 goBack(): void {
   this.location.back();
 }


}
